import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';

export function setFormErrors(errorsObj: any, form: UntypedFormGroup | UntypedFormArray): void {
  if (typeof errorsObj === 'string') {
    return;
  }

  if (Array.isArray(errorsObj)) {
    for (let i = 0; i < errorsObj.length; i++) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setFormErrors(errorsObj[i]['children'], form?.controls[i]);
    }
    return;
  }

  for (const key in errorsObj) {
    if (!Object.prototype.hasOwnProperty.call(errorsObj, key)) {
      continue;
    }

    if (typeof errorsObj[key] === 'object' && errorsObj[key] !== null && !Array.isArray(errorsObj[key])) {
      const errors = {};
      for (const err in errorsObj[key]) {
        if (Object.prototype.hasOwnProperty.call(errorsObj[key], err)) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          errors[err] = errorsObj[key][err];
        }
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (Object.keys(errors).length > 0 && errors['errors'] && form.get(key)) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        form.get(key).setErrors({ backend: { errors: errors['errors'][0] } });
      }
    } else if (form.get(key)) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      form.get(key).setErrors({ backend: [errorsObj[key]] });
    }
  }
}
